export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyBdg8k8HUG_iMhCqQ_AiYC4DURosYtMgdg",
        authDomain: "crust-game-of-life-dev.firebaseapp.com",
        projectId: "crust-game-of-life-dev",
        storageBucket: "crust-game-of-life-dev.firebasestorage.app",
        messagingSenderId: "713477069536",
        appId: "1:713477069536:web:875e7ca1f3d0838ef24e85",
        measurementId: "G-9ZE7WN493V",
        appCheck: {
            recaptchaSiteKey: "6LemeBwsAAAAADS2DS_S7Ni6qo3geGPyE-5FHuUh"
        }
    }
};